import { TestResult } from '../types/tests';

const getFullAnswers = (result: TestResult): string => {
    if (!result.test || !result.userResponses) return '';

    const answers = result.test.questions.map((q, i) => {
        const response = result.userResponses?.find(r => r.questionId === q.id);
        const answer = q.answers.find(a => a.id === response?.answerId);
        const answerIndex = q.answers.findIndex(a => a.id === response?.answerId);

        // Use question text as is if it starts with number, otherwise prepend index
        const questionText = q.text.match(/^\d+\./) ? q.text : `${i + 1}. ${q.text}`;

        return `${questionText}\n   Ваш ответ: (${answerIndex + 1}) ${answer?.text || 'Не отвечено'}`;
    }).join('\n\n');

    return `\n\nВАШИ ОТВЕТЫ:\n${answers}`;
};



const getTelegramAnswers = (result: TestResult): string => {
    if (!result.test || !result.userResponses) return '';

    const answers = result.test.questions.map((q, i) => {
        const response = result.userResponses?.find(r => r.questionId === q.id);
        const answerIndex = q.answers.findIndex(a => a.id === response?.answerId);

        // Ultra compact format: "1(4)" to avoid URL length limits with Cyrillic
        return `${i + 1}(${answerIndex + 1})`;
    }).join(', ');

    return `\n\nОтветы: ${answers}`;
};

const formatResultSummary = (result: TestResult): string => {
    let summary = `${result.testTitle}\n\n`;

    if (result.subScores && result.subScores.length > 0) {
        // Format for subscales (e.g. HADS)
        summary += 'Мои результаты:\n';
        result.subScores.forEach(sub => {
            summary += `${sub.subscaleTitle}: ${sub.category} (${sub.score} б.)\n`;
        });

        // Add main interpretation if available and not redundant
        if (result.interpretation) {
            summary += `\n${result.interpretation}`;
        }
    } else {
        // Standard format
        summary += `Мой результат: ${result.category}\nБаллы: ${result.totalScore}\n\n${result.interpretation}`;
    }

    return summary;
};

export const shareTelegram = (result: TestResult): void => {
    let text = formatResultSummary(result);

    if (result.test && result.userResponses) {
        text += getTelegramAnswers(result);
    }

    const url = `https://t.me/share/url?url=${encodeURIComponent(window.location.origin + '/materials')}&text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const shareWhatsApp = (result: TestResult): void => {
    let text = formatResultSummary(result);

    if (result.test && result.userResponses) {
        text += getTelegramAnswers(result);
    }

    text += `\n\nПройдите тест сами: ${window.location.origin}/materials`;

    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const downloadResults = (result: TestResult): void => {
    let answersText = '';
    if (result.test && result.userResponses) {
        answersText = getFullAnswers(result);
    }

    let resultDetails = '';
    if (result.subScores && result.subScores.length > 0) {
        resultDetails = result.subScores.map(sub => `
${sub.subscaleTitle}
------------------
Баллы: ${sub.score}
Категория: ${sub.category}
Интерпретация: ${sub.interpretation}
${sub.longDescription ? sub.longDescription : ''}
        `).join('\n');
    } else {
        resultDetails = `
РЕЗУЛЬТАТ: ${result.category}
Баллы: ${result.totalScore}

${result.interpretation}

${result.longDescription}
        `;
    }

    // Create a formatted text version
    const text = `
${result.testTitle}
${'='.repeat(result.testTitle.length)}

Дата прохождения: ${new Date(result.completedAt).toLocaleDateString('ru-RU')}

${resultDetails.trim()}

${answersText}

---
Тест пройден на сайте психолога Ольги Гальперин
${window.location.origin}
  `.trim();

    // Create blob and download
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${result.testTitle.replace(/\s+/g, '_')}_${new Date(result.completedAt).toISOString().split('T')[0]}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
